export const create =  "CREATE";
export const fetchbooks = "FETCH_BOOKS";
export const remove = "REMOVE";
export const update= "UPDATE";
export const fetchstationary = "FETCH_STATIONARY";
export const fetchSingleStationary = 'FETCH_SINGLE_STATIONARY';
export const logout = "LOGOUT";
export const auth = "AUTH";